// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/png/loginbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Proxima Nova"; }

.flex {
  display: flex; }

.align-center {
  align-items: center; }

.justify-center {
  justify-content: center; }

.dir-col {
  flex-direction: column; }

.container {
  height: 100vh;
  width: 100%;
  display: flex;
  position: relative; }
  .container::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0; }
  .container .logo-container {
    width: 50%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat, repeat;
    background-size: cover; }
    .container .logo-container h1 {
      font-size: 64.5px;
      line-height: 65px;
      margin: 0px;
      padding-left: 14px; }
    .container .logo-container .logo {
      width: 273px;
      height: 80px; }
  .container .form-container {
    width: 50%;
    margin: auto;
    z-index: 1;
    padding: 80px; }
    .container .form-container .box {
      width: 500px; }
      .container .form-container .box h2 {
        font-size: 55px;
        font-weight: bold;
        padding-bottom: 50px; }
      .container .form-container .box .ant-input {
        padding: 12px !important; }
      .container .form-container .box .ant-form-item-control-input-content {
        width: 100% !important;
        max-width: 446px !important; }
      .container .form-container .box .ant-form {
        width: 446px; }
      .container .form-container .box .ant-form-item-control-input {
        width: 100% !important; }
      .container .form-container .box .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
        display: none !important; }
      .container .form-container .box .ant-checkbox-wrapper {
        color: #637f92 !important; }
      .container .form-container .box .ant-input:focus,
      .container .form-container .box .ant-input-focused,
      .container .form-container .box .ant-input:hover,
      .container .form-container .box .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
      .container .form-container .box .ant-input-affix-wrapper:focus {
        border-color: #586f80 !important;
        box-shadow: none !important; }
      .container .form-container .box .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #586f80 !important;
        border-color: #586f58 !important; }
      .container .form-container .box .ant-checkbox-wrapper:hover .ant-checkbox-inner,
      .container .form-container .box .ant-checkbox:hover .ant-checkbox-inner,
      .container .form-container .box .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: #586f58 !important; }
      .container .form-container .box .ant-input-affix-wrapper {
        padding: 0px 4px 0px 0px !important; }
      .container .form-container .box .ant-form-item-control-input-content {
        display: flex !important;
        justify-content: space-between !important; }
      .container .form-container .box .ant-btn-primary {
        border-color: #586f80 !important;
        background: #586f80 !important; }

.login-form-forgot {
  color: #637f92; }
  .login-form-forgot:hover {
    color: #586f80; }

.login-form-button {
  height: 44px !important; }

.loginDashboard {
  background: #000;
  color: #fff;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center; }
  .loginDashboard p {
    font-size: 24px;
    margin-bottom: 56px; }
  .loginDashboard h2 {
    color: #fff;
    font-size: 38.3px;
    margin-bottom: 0px; }
  .loginDashboard .beauty-travel-img {
    width: 149px;
    height: 131px; }
  .loginDashboard .logo {
    color: #fff;
    width: 30px;
    height: 30px;
    margin-right: 12px; }
  .loginDashboard .wrapper {
    margin: 24px; }
  .loginDashboard .logo-wrapper {
    padding-top: 24px; }
`, "",{"version":3,"sources":["webpack://./src/pages/Login/styles.scss"],"names":[],"mappings":"AAAA;EACI,2BAA2B,EAAA;;AAG/B;EACI,aAAa,EAAA;;AAGjB;EACI,mBAAmB,EAAA;;AAGvB;EACI,uBAAuB,EAAA;;AAG3B;EACI,sBAAsB,EAAA;;AAG1B;EACI,aAAa;EACb,WAAW;EACX,aAAa;EACb,kBAAkB,EAAA;EAJtB;IAOQ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS,EAAA;EAZjB;IAgBQ,UAAU;IACV,yDAAqD;IACrD,oCAAoC;IACpC,sBAAsB,EAAA;IAnB9B;MAsBY,iBAAiB;MACjB,iBAAiB;MACjB,WAAW;MACX,kBAAkB,EAAA;IAzB9B;MA6BY,YAAY;MACZ,YAAY,EAAA;EA9BxB;IAmCQ,UAAU;IACV,YAAY;IACZ,UAAU;IACV,aAAa,EAAA;IAtCrB;MAyCY,YAAY,EAAA;MAzCxB;QA4CgB,eAAe;QACf,iBAAiB;QACjB,oBAAoB,EAAA;MA9CpC;QAkDgB,wBAAwB,EAAA;MAlDxC;QAsDgB,sBAAsB;QACtB,2BAA2B,EAAA;MAvD3C;QA2DgB,YAAY,EAAA;MA3D5B;QA+DgB,sBAAsB,EAAA;MA/DtC;QAmEgB,wBAAwB,EAAA;MAnExC;QAuEgB,yBAAyB,EAAA;MAvEzC;;;;;QA+EgB,gCAAgC;QAChC,2BAA2B,EAAA;MAhF3C;QAoFgB,oCAAoC;QACpC,gCAAgC,EAAA;MArFhD;;;QA2FgB,gCAAgC,EAAA;MA3FhD;QA+FgB,mCAAmC,EAAA;MA/FnD;QAmGgB,wBAAwB;QACxB,yCAAyC,EAAA;MApGzD;QAwGgB,gCAAgC;QAChC,8BAA8B,EAAA;;AAM9C;EACI,cAAc,EAAA;EADlB;IAIQ,cAAc,EAAA;;AAItB;EACI,uBAAuB,EAAA;;AAG3B;EACI,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EAP3B;IAUQ,eAAe;IACf,mBAAmB,EAAA;EAX3B;IAeQ,WAAW;IACX,iBAAiB;IACjB,kBAAkB,EAAA;EAjB1B;IAqBQ,YAAY;IACZ,aAAa,EAAA;EAtBrB;IA0BQ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAA;EA7B1B;IAiCQ,YAAY,EAAA;EAjCpB;IAqCQ,iBAAiB,EAAA","sourcesContent":["* {\n    font-family: \"Proxima Nova\";\n}\n\n.flex {\n    display: flex;\n}\n\n.align-center {\n    align-items: center;\n}\n\n.justify-center {\n    justify-content: center;\n}\n\n.dir-col {\n    flex-direction: column;\n}\n\n.container {\n    height: 100vh;\n    width: 100%;\n    display: flex;\n    position: relative;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n    }\n\n    .logo-container {\n        width: 50%;\n        background-image: url(\"../../assets/png/loginbg.png\");\n        background-repeat: no-repeat, repeat;\n        background-size: cover;\n\n        h1 {\n            font-size: 64.5px;\n            line-height: 65px;\n            margin: 0px;\n            padding-left: 14px;\n        }\n\n        .logo {\n            width: 273px;\n            height: 80px;\n        }\n    }\n\n    .form-container {\n        width: 50%;\n        margin: auto;\n        z-index: 1;\n        padding: 80px;\n\n        .box {\n            width: 500px;\n\n            h2 {\n                font-size: 55px;\n                font-weight: bold;\n                padding-bottom: 50px;\n            }\n\n            .ant-input {\n                padding: 12px !important;\n            }\n\n            .ant-form-item-control-input-content {\n                width: 100% !important;\n                max-width: 446px !important;\n            }\n\n            .ant-form {\n                width: 446px;\n            }\n\n            .ant-form-item-control-input {\n                width: 100% !important;\n            }\n\n            .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n                display: none !important;\n            }\n\n            .ant-checkbox-wrapper {\n                color: #637f92 !important;\n            }\n\n            .ant-input:focus,\n            .ant-input-focused,\n            .ant-input:hover,\n            .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,\n            .ant-input-affix-wrapper:focus {\n                border-color: #586f80 !important;\n                box-shadow: none !important;\n            }\n\n            .ant-checkbox-checked .ant-checkbox-inner {\n                background-color: #586f80 !important;\n                border-color: #586f58 !important;\n            }\n\n            .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n            .ant-checkbox:hover .ant-checkbox-inner,\n            .ant-checkbox-input:focus + .ant-checkbox-inner {\n                border-color: #586f58 !important;\n            }\n\n            .ant-input-affix-wrapper {\n                padding: 0px 4px 0px 0px !important;\n            }\n\n            .ant-form-item-control-input-content {\n                display: flex !important;\n                justify-content: space-between !important;\n            }\n\n            .ant-btn-primary {\n                border-color: #586f80 !important;\n                background: #586f80 !important;\n            }\n        }\n    }\n}\n\n.login-form-forgot {\n    color: #637f92;\n\n    &:hover {\n        color: #586f80;\n    }\n}\n\n.login-form-button {\n    height: 44px !important;\n}\n\n.loginDashboard {\n    background: #000;\n    color: #fff;\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    p {\n        font-size: 24px;\n        margin-bottom: 56px;\n    }\n\n    h2 {\n        color: #fff;\n        font-size: 38.3px;\n        margin-bottom: 0px;\n    }\n\n    .beauty-travel-img {\n        width: 149px;\n        height: 131px;\n    }\n\n    .logo {\n        color: #fff;\n        width: 30px;\n        height: 30px;\n        margin-right: 12px;\n    }\n\n    .wrapper {\n        margin: 24px;\n    }\n\n    .logo-wrapper {\n        padding-top: 24px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
